module.exports = __webpack_public_path__ + "img/rfpromotionimg.4fafba0a.gif";